export const MANAGE_PLAN_PAYPAL_LINK =
  'https://support.form-publisher.com/hc/en-us/sections/360004552020-Manage-your-licenses-purchased-with-Paypal-account-or-by-card-via-Paypal';
export const CANCEL_PLAN_PAYPAL_LINK = `${window.location.protocol}//${window.location.host}/stop-automatic-renewal`;
